import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import lang from '@blade-sxp/monitor-center/lang/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import moment from 'moment';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    dataObj;
    moment = moment;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    activeBorderColor = colors.borderItemHover;
};
__decorate([
    Prop()
], default_1.prototype, "dataObj", void 0);
default_1 = __decorate([
    Component({
        components: {
            BlurPicture,
        },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
